export default __webpack_public_path__ + "de829545eb9e2411f61e266b7885fe8e.png";